import React from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import ProductGenres from '../../../shared/product/ProductGenres';
import ProductAge from '../../../shared/product/ProductAge';
import { ProductFormat } from '../../../shared/product/ProductFormat';
import ProductPublisher from '../../../shared/product/ProductPublisher';
import { ProductReleaseDate } from '../../../shared/product/ProductReleaseDate';
import ProductUsageConditions from '../../../shared/product/ProductUsageConditions';
import LibxAddToCollectionButton from '../shared/LibxAddToCollectionButton';
import ProductLanguage from '../../../shared/product/ProductLanguage';
import { LOANFORMAT_EBOOK_OBJECT } from '../../../store/loanFormat/actions';
import { ButtonSize } from '../../../shared/common/Button';
import { ProductMetaData } from '../../../../models/Product';
import { AdditionalLibxProps } from './api/fetchLibxProduct';
import { LoanFormat } from '../../../../models/LoanFormat';

const SidebarContainer = styled.div`
    width: 215px;
    flex-grow: 0;
`;

interface ButtonProps {}

const StButton = styled(LibxAddToCollectionButton)<ButtonProps>`
    margin-bottom: 25px;
`;

interface Props {
    product: ProductMetaData & AdditionalLibxProps;
    addToCollection: (productId: string) => void;
}

export const LibxProductDetailSidebar = (props: Props) => {
    const { product } = props;
    const loanFormatKey = LOANFORMAT_EBOOK_OBJECT.key;
    const releasedLabel = !isEmpty(product.salesStatus) && product?.salesStatus?.key === 'AVAILABLE' ? 'Released' : '';

    const preparedProduct = { ...product, loanFormat: LOANFORMAT_EBOOK_OBJECT.name as LoanFormat };
    return (
        <SidebarContainer className="ca-side">
            <div className="ca-side-inner" data-displayname="LibxProductDetailSidebar">
                <StButton
                    size={ButtonSize.LARGE}
                    onAddToCollection={props.addToCollection}
                    product={props.product}
                    fullWidth={true}
                />
                <ProductFormat
                    product={preparedProduct}
                    showIcon={true}
                    loanFormatKey={loanFormatKey}
                    shopLanguage={undefined}
                />

                <ProductReleaseDate product={product} label={releasedLabel} />

                <ProductAge product={product} isLibx={true} loanFormatKey={loanFormatKey} shopLanguage={undefined} />

                <ProductLanguage
                    product={product}
                    loanFormatKey={loanFormatKey}
                    label={product.language}
                    shopLanguage={undefined}
                />

                <ProductUsageConditions
                    product={product}
                    showDetails={true}
                    loanFormatKey={loanFormatKey}
                    shopLanguage={undefined}
                />

                <p>{product.isbn13}</p>

                <div className="genres">
                    <h4>Genres</h4>
                    <ProductGenres
                        product={product}
                        showGenresInSeparateLines="true"
                        showDetails={true}
                        isLibx={true}
                        loanFormatKey={loanFormatKey}
                        shopLanguage={undefined}
                    />
                </div>

                <div className="publishers">
                    <h4>Publisher</h4>
                    <ProductPublisher product={product} loanFormatKey={loanFormatKey} shopLanguage={undefined} />
                </div>
            </div>
        </SidebarContainer>
    );
};
